import {isPlainObject} from 'lodash'

function defaultSendDataOptions() {
  return {
    skipErrors: false,
  };
}

export default {
  data() {
    return {
      overallErrorsMix: null,
      isRequiredEmptyMix: false
    }
  },
  methods: {
    createSendDataMix(inputs, { skipErrors } = defaultSendDataOptions()) {
      const data = {}
      for (const [key, obj] of Object.entries(inputs)) {
        const idObjectModel = isPlainObject(obj.value) && obj.value.hasOwnProperty('id')
        data[key] = idObjectModel ? obj.value.id : obj.value

        if (skipErrors) continue;
        let r = this.moderateFieldIsRequiredMix(obj)
        if (!r) {
          this.isRequiredEmptyMix = true
        }
      }

      return data
    },
    errorHandlerMix(errorObj, inputs) {
      if (!inputs) inputs = this.inputs

      if (!errorObj.response || !errorObj.response.data) {
        return this.overallErrorsMix = [errorObj.message]
      }

      if (!errorObj.response.data.errors && !errorObj.response.data.message) {
        return this.overallErrorsMix = [errorObj.message]
      }

      if (errorObj.response.data.errors) {
        if (inputs) {
          for (let key in errorObj.response.data.errors) {

            if (inputs.hasOwnProperty(key)) {
              this.$set(inputs[key], 'error', errorObj.response.data.errors[key])
            }
          }
        } else {
          this.overallErrorsMix = errorObj.response.data.errors
        }
      }

      if (errorObj.response.data.message) {
        this.overallErrorsMix = errorObj.response.data.message
      }
    },
    moderateFieldIsRequiredMix(field) {
      if (field.required && !field.value) {
        this.$set(field, 'error', 'This field is required')
        return false
      }

      return true
    },
    resetErrorsMix(inputs) {
      this.isRequiredEmptyMix = false
      this.overallErrorsMix = null

      // - -

      if (!inputs) inputs = this.inputs
      if (!inputs) return

      for (let key in inputs) {
        this.$set(inputs[key], 'error', null)
      }
    }
  }
}
